<p-panel #panelRef #panelElementRef [toggleable]="true" [(collapsed)]="isCollapsed" [toggler]="'header'"
  [ngClass]="{ 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
  <ng-template pTemplate="header">
    <div class="title">
      <label class="title-label" id="panel-header-title">{{'iaa.app.advancedSearch.searchOptions' | translate }}</label>
      <i tabIndex="0" role="button" class="pi pi-info-circle"
        [ngClass]="{currentLang:true,'info-icon' : true, 'en': currentLanguage ==='en'}" tooltipEvent="both"
        [tooltipPosition]="currentLanguage === 'en' ? 'right' : 'left'"
        [attr.aria-description]=" 'iaa.app.advancedSearch.infoDdescription' | translate "
        [attr.aria-label]="'iaa.aria.info' | translate " [pTooltip]=" 'iaa.app.advancedSearch.infoDdescription' | translate "></i>
    </div>
  </ng-template>
  <ng-template pTemplate="headericons">
    <i aria-labelledby="panel-header-title" class="pi panel-toggle-icon"
      [ngClass]="{'pi-angle-up' : !isCollapsed, 'pi-angle-down': isCollapsed}"></i>
  </ng-template>
  <div *ngIf="isMobile"class="not-supported">{{'iaa.authentication.mobileNotSupported' |translate}}</div>
  
  <div [ngClass]="{'search-container' : true, 'en': currentLanguage ==='en', 'he':currentLanguage ==='he'}">
    <div [class.selected]="isEntityTypeVisible" class="item-container">
      <div #entityTypeOpener id="entityTypeOpener" role="button" class=" open-dialog-btn" tabindex="0" (click)="isEntityTypeVisible = true"
        (keydown.enter)="isEntityTypeVisible = true">
        <i class="pi pi-plus-circle cursor-pointer ml-2 text-white border-circle plus-icon shadow-2 text-xl"
          [ngClass]="{ 'en': currentLanguage === 'en', 'he': currentLanguage === 'he' }"></i>
        <label class="item-label" htmlFor="entityType">{{'iaa.general.sourceType' | translate }}</label>
      </div>
      <app-filter-tags (removeTag)="removeTag($event, RequestKeys.ENTITY_TYPES)"
        [tagList]="searchFields[RequestKeys.ENTITY_TYPES]" />
      <p-dialog [closeAriaLabel]=" 'iaa.general.closePane' | translate " [(visible)]="isEntityTypeVisible"
        [dismissableMask]="true" [modal]="true" [header]=" 'iaa.app.advancedSearch.selectSourceType' | translate "
        maskStyleClass="dialog-mask"
        (onHide)="onDialogHide('entityType')"
        [ngClass]="{ 'dialog': true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
        <search-dialog *ngIf="isEntityTypeVisible" (onToggleTag)="toggleField(RequestKeys.ENTITY_TYPES, $event)" [fieldName]="'entityTypeName'"
          [fieldNameByLang]="'iaa.general.sourceType' | translate" [key]="'id'" [isVisible]="isEntityTypeVisible"
          [values]="fieldsLists.entityTypes" [currentLanguage]="currentLanguage" />
        <div [ngClass]="{'dialog-footer':true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
          <p-button [id]="'ok'" (onClick)="isEntityTypeVisible = false" (keydown.enter)="isEntityTypeVisible = false"
            [rounded]="true" [styleClass]="'prime-button'" [label]="'iaa.general.ok' | translate" [tabIndex]="0" />
        </div>
      </p-dialog>
    </div>
    <div [class.selected]="isFindTypeVisible" class="item-container">
      <div class="search-field">
        <div #findTypeOpener id="findTypeOpener" role="button" aria-describedby="search-info" tabindex="0" class=" open-dialog-btn"
          (click)="isFindTypeVisible = true" (keydown.enter)="isFindTypeVisible = true">
          <i class="pi pi-plus-circle cursor-pointer ml-2 text-white border-circle plus-icon shadow-2 text-xl"
            [ngClass]="{ 'en': currentLanguage === 'en', 'he': currentLanguage === 'he' }"></i>
          <label class="item-label" htmlFor="findType">{{'iaa.app.advancedSearch.artifacType' | translate}}</label>
        </div>
        <img [ngClass]="{'icon-book':currentLanguage ==='en'}" src="assets/book.svg" alt="" />
      </div>
      <app-filter-tags (removeTag)="removeTag($event, RequestKeys.FIND_TYPE_MIDS)"
        [tagList]="searchFields[RequestKeys.FIND_TYPE_MIDS]" />
    </div>
    <p-dialog [closeAriaLabel]=" 'iaa.general.closePane' | translate " [(visible)]="isFindTypeVisible"
      [dismissableMask]="true" [modal]="true" [header]=" 'iaa.app.advancedSearch.selectArtifacType' | translate "
      (onHide)="onDialogHide('findType')"
      [ngClass]="{ 'dialog': true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
      <app-search-tree (onToggle)="toggleField(RequestKeys.FIND_TYPE_MIDS, $event)" *ngIf="isFindTypeVisible"
        [tree]="fieldsLists.findTypes" [currentLanguage]="currentLanguage" />
      <div [ngClass]="{'dialog-footer':true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
        <p-button [id]="'ok'" (onClick)="isFindTypeVisible = false" (keydown.enter)="isFindTypeVisible = false"
          [rounded]="true" [styleClass]="'prime-button'" [label]="'iaa.general.ok' | translate" [tabIndex]="0" />
      </div>
    </p-dialog>
    <div [class.selected]="isPeriodVisible" class="item-container">
      <div class="search-field">
        <div #periodOpener id="periodOpener" role="button" aria-describedby="search-info" tabindex="0" class=" open-dialog-btn"
          (click)="isPeriodVisible = true" (keydown.enter)="isPeriodVisible = true">
          <i class="pi pi-plus-circle cursor-pointer ml-2 text-white border-circle plus-icon shadow-2 text-xl"
            [ngClass]="{ 'en': currentLanguage === 'en', 'he': currentLanguage === 'he' }"></i>
          <label class="item-label" htmlFor="period">{{ 'iaa.general.period' | translate }}</label>
        </div>
        <img [ngClass]="{'icon-book':currentLanguage ==='en'}" src="assets/book.svg" alt="" />
      </div>
      <app-filter-tags (removeTag)="removeTag($event, RequestKeys.PERIOD_MIDS)"
        [tagList]="searchFields[RequestKeys.PERIOD_MIDS]" />
      <p-dialog [closeAriaLabel]=" 'iaa.general.closePane' | translate " [(visible)]="isPeriodVisible"
        [dismissableMask]="true" [modal]="true" [header]=" 'iaa.app.advancedSearch.selectPeriod' | translate "

        (onHide)="onDialogHide('period')"
        [ngClass]="{ 'dialog': true, 'he': currentLanguage === 'he', 'en':currentLanguage === 'en' }">
        <app-search-tree (onToggle)="toggleField(RequestKeys.PERIOD_MIDS, $event)" *ngIf="isPeriodVisible"
          [tree]="fieldsLists.periods" [currentLanguage]="currentLanguage" />
        <div [ngClass]="{'dialog-footer':true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
          <p-button [id]="'ok'" (onClick)="isPeriodVisible = false" (keydown.enter)="isPeriodVisible = false"
            [rounded]="true" [styleClass]="'prime-button'" [label]="'iaa.general.ok' | translate" [tabIndex]="0" />
        </div>
      </p-dialog>
    </div>
    <div [class.selected]="isMaterialVisible" class="item-container">
      <div class="search-field">
        <div #materialOpener id="materialOpener" role="button" aria-describedby="search-info" class=" open-dialog-btn" tabindex="0"
          (click)="isMaterialVisible = true" (keydown.enter)="isMaterialVisible = true">
          <i class="pi pi-plus-circle cursor-pointer ml-2 text-white border-circle plus-icon shadow-2 text-xl"
            [ngClass]="{ 'en': currentLanguage=== 'en', 'he': currentLanguage === 'he' }"></i>
          <label class="item-label" htmlFor="material">{{'iaa.app.advancedSearch.material' | translate }}</label>
        </div>
        <img [ngClass]="{'icon-book':currentLanguage==='en'}" src="assets/book.svg" alt="" />
      </div>
      <app-filter-tags (removeTag)="removeTag($event, RequestKeys.MATERIAL_MIDS)"
        [tagList]="searchFields[RequestKeys.MATERIAL_MIDS]" />
      <p-dialog [closeAriaLabel]=" 'iaa.general.closePane' | translate " [(visible)]="isMaterialVisible"
        [dismissableMask]="true" [modal]="true" [header]="'iaa.app.advancedSearch.selectMaterial' | translate "
        (onHide)="onDialogHide('material')"
        [ngClass]="{ 'dialog': true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
        <app-search-tree (onToggle)="toggleField(RequestKeys.MATERIAL_MIDS, $event)" *ngIf="isMaterialVisible"
          [tree]="fieldsLists.materials" [currentLanguage]="currentLanguage" />
        <div [ngClass]="{'dialog-footer':true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
          <p-button [id]="'ok'" (onClick)="isMaterialVisible = false" (keydown.enter)="isMaterialVisible = false"
            [rounded]="true" [styleClass]="'prime-button'" [label]="'iaa.general.ok' | translate" [tabIndex]="0" />
        </div>
      </p-dialog>
    </div>


<div [class.selected]="isExpeditionVisible" class="item-container">
  <div class="search-field">
    <div #expeditionOpener id="expeditionOpener" role="button" aria-describedby="search-info" class=" open-dialog-btn" tabindex="0"
      (click)="openExpeditionDialog()" (keydown.enter)="openExpeditionDialog()">
      <i class="pi pi-plus-circle cursor-pointer ml-2 text-white border-circle plus-icon shadow-2 text-xl"
        [ngClass]="{ 'en': currentLanguage=== 'en', 'he': currentLanguage === 'he' }"></i>
      <label class="item-label" htmlFor="expedition">{{'iaa.app.advancedSearch.expedition' | translate }}</label>
    </div>
  </div>

    <app-filter-tags (removeTag)="removeTag($event, RequestKeys.EXPEDITION_LICENSES)"
      [tagList]="searchFields[RequestKeys.EXPEDITION_LICENSES]" />
    <app-filter-tags (removeTag)="removeTag($event, RequestKeys.EXPEDITIONS)"
      [tagList]="searchFields[RequestKeys.EXPEDITIONS]" />
    
    <p-dialog [closeAriaLabel]="'iaa.general.closePane' | translate" [(visible)]="isExpeditionDialogVisible"
      [dismissableMask]="true" [modal]="true" 
      [header]="'iaa.app.advancedSearch.selectExpedition' | translate"
      (onHide)="onDialogHide('expedition')"
      [ngClass]="{ 'dialog': true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
      
      <search-dialog 
        *ngIf="isExpeditionDialogVisible"
        (onToggleTag)="handleExpeditionToggleTag($event)" 
        [key]="'id'"
        [fieldName]="'name'"
        [fieldNameByLang]="'iaa.app.advancedSearch.expedition' | translate"
        [isVisible]="isExpeditionDialogVisible" 
        [values]="combinedExpeditionValues" 
        [currentLanguage]="currentLanguage">
      </search-dialog>
      
      <div [ngClass]="{'dialog-footer':true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
        <p-button [id]="'ok'" (onClick)="closeExpeditionDialog()" (keydown.enter)="closeExpeditionDialog()"
          [rounded]="true" [styleClass]="'prime-button'" [label]="'iaa.general.ok' | translate" [tabIndex]="0" />
      </div>
    </p-dialog>
</div>


<!-- Excavations and Surveys Combined Dropdown -->
<div [class.selected]="isExcavationsAndSurveysVisible" class="item-container">
  <div class="search-field">
    <div #excavationsAndSurveysOpener id="excavationsAndSurveysOpener" role="button" aria-describedby="search-info" class=" open-dialog-btn" tabindex="0"
      (click)="openExcavationsAndSurveysDialog()" (keydown.enter)="openExcavationsAndSurveysDialog()">
      <i class="pi pi-plus-circle cursor-pointer ml-2 text-white border-circle plus-icon shadow-2 text-xl"
        [ngClass]="{ 'en': currentLanguage=== 'en', 'he': currentLanguage === 'he' }"></i>
      <label class="item-label" htmlFor="excavation-survey">{{'iaa.app.advancedSearch.excavationAndSurvey' | translate }}</label>
    </div>
  </div>

    <app-filter-tags (removeTag)="removeTag($event, RequestKeys.EXCAVATION_LICENSES)"
      [tagList]="searchFields[RequestKeys.EXCAVATION_LICENSES]" />
    <app-filter-tags (removeTag)="removeTag($event, RequestKeys.EXCAVATIONS)"
      [tagList]="searchFields[RequestKeys.EXCAVATIONS]" />
    <app-filter-tags (removeTag)="removeTag($event, RequestKeys.SURVEY_LICENSES)"
      [tagList]="searchFields[RequestKeys.SURVEY_LICENSES]" />
    <app-filter-tags (removeTag)="removeTag($event, RequestKeys.SURVEYS)"
      [tagList]="searchFields[RequestKeys.SURVEYS]" />
    
    <p-dialog [closeAriaLabel]="'iaa.general.closePane' | translate" [(visible)]="isExcavationsAndSurveysDialogVisible"
      [dismissableMask]="true" [modal]="true" 
      [header]="'iaa.app.advancedSearch.selectExcavationAndSurvey' | translate"
      (onHide)="onDialogHide('excavationsAndSurveys')"
      [ngClass]="{ 'dialog': true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
      
      <search-dialog 
        *ngIf="isExcavationsAndSurveysDialogVisible"
        (onToggleTag)="handleExcavationAndSurveyToggleTag($event)" 
        [key]="'id'"
        [fieldName]="'name'"
        [fieldNameByLang]="'iaa.app.advancedSearch.excavationAndSurvey' | translate"
        [isVisible]="isExcavationsAndSurveysDialogVisible" 
        [values]="combinedExcavationsAndSurveysValues" 
        [currentLanguage]="currentLanguage">
      </search-dialog>
      
      <div [ngClass]="{'dialog-footer':true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
        <p-button [id]="'ok'" (onClick)="isExcavationsAndSurveysDialogVisible = false" (keydown.enter)="isExcavationsAndSurveysDialogVisible = false"
          [rounded]="true" [styleClass]="'prime-button'" [label]="'iaa.general.ok' | translate" [tabIndex]="0" />
      </div>
    </p-dialog>
</div>


    <div [ngClass]="{'item-container': !isRegionVisible, 'item-container-region': isRegionVisible}">
      <div class="open-dialog-btn" role="button" tabindex="0" [attr.aria-expanded]="isRegionVisible"
        (click)="toggleRegionVisibility()" (keydown.enter)="toggleRegionVisibility()">
        <i class="pi cursor-pointer ml-2 text-white border-circle plus-icon shadow-2 text-xl" [ngClass]="{
        'pi-plus-circle': !isRegionVisible,
        'pi-minus-circle': isRegionVisible,'en': currentLanguage === 'en', 'he': currentLanguage === 'he'  }"></i>
        <label class="item-label" htmlFor="region">{{'iaa.app.advancedSearch.location' | translate}}</label>
      </div>
      <div class="indented">
        <div #merchaOpener id="merchaOpener" *ngIf="isRegionVisible" class="open-dialog-btn" role="button" tabindex="0" (click)="isMerchaVisible = true"
          (keydown.enter)="isMerchaVisible = true">
          <i class="pi pi-plus-circle cursor-pointer ml-2 text-white border-circle plus-icon shadow-2 text-xl"
            [ngClass]="{ 'en': currentLanguage === 'en', 'he': currentLanguage === 'he' }"></i>
          <label class="item-label" htmlFor="region">{{'iaa.app.advancedSearch.region' | translate}}</label>
        </div>
        <app-filter-tags (removeTag)="removeTag($event, RequestKeys.REGION_IDS)"
          [tagList]="searchFields[RequestKeys.REGION_IDS]" />
          <div #settlementOpener id="settlementOpener" *ngIf="isRegionVisible" class="open-dialog-btn" role="button" tabindex="0" (click)="isSettlementVisible = true"
          (keydown.enter)="isSettlementVisible = true">
          <i class="pi pi-plus-circle cursor-pointer ml-2 text-white border-circle plus-icon shadow-2 text-xl"
            [ngClass]="{ 'en': currentLanguage === 'en', 'he': currentLanguage === 'he' }"></i>
          <label class="item-label" htmlFor="region">{{'iaa.app.advancedSearch.settlement' | translate}}</label>
        </div>
        <app-filter-tags (removeTag)="removeTag($event, RequestKeys.SETTLEMENT_IDS)"
          [tagList]="searchFields[RequestKeys.SETTLEMENT_IDS]" />

        <div #drawPolygonOpener id="drawPolygonOpener" *ngIf="isRegionVisible" class="open-dialog-btn" role="button" tabindex="0" (click)="isDrawPolygon = true"
          (keydown.enter)="isDrawPolygon = true">
          <i class="pi cursor-pointer ml-2 text-white border-circle plus-icon shadow-2 text-xl" [ngClass]="{
          'pi-plus-circle ': !isDrawPolygon,
          'pi-minus-circle ': isDrawPolygon,
          'en':currentLanguage === 'en', 'he': currentLanguage === 'he'}"></i>
          <label class="item-label" htmlFor="region"> {{'iaa.app.advancedSearch.drawingPolygonMap' | translate}}</label>
        </div>
        <app-filter-tags (removeTag)="removeAllRegionsTag(RequestKeys.REGIONS)"
          [tagList]="searchFields[RequestKeys.REGIONS].slice(-1)" />
      </div>
      <p-dialog [closeAriaLabel]=" 'iaa.general.closePane' | translate " [(visible)]="isMerchaVisible"
        [dismissableMask]="true" [modal]="true" [header]="'iaa.app.advancedSearch.selectRegion' | translate"
        (onHide)="onDialogHide('mercha')"
        [ngClass]="{ 'dialog': true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
        <search-dialog *ngIf="isMerchaVisible" (onToggleTag)="toggleField(RequestKeys.REGION_IDS, $event)" [key]="'id'"
          [fieldName]="'name'" [fieldNameByLang]="'iaa.app.advancedSearch.region' | translate"
          [isVisible]="isMerchaVisible" [values]="fieldsLists.regions" [currentLanguage]="currentLanguage">
        </search-dialog>
        <div [ngClass]="{'dialog-footer':true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
          <p-button [id]="'ok'" (onClick)="isMerchaVisible = false" (keydown.enter)="isMerchaVisible = false"
            [rounded]="true" [styleClass]="'prime-button'" [label]="'iaa.general.ok' | translate" [tabIndex]="0" />
        </div>
      </p-dialog>
      <p-dialog [closeAriaLabel]=" 'iaa.general.closePane' | translate "
        [(visible)]="isDrawPolygon" [modal]="true"
        [header]="'iaa.app.advancedSearch.drawingPolygonAndDoubleTap' | translate"
        (onHide)="onDialogHide('drawPolygon')"
        [ngClass]="{ 'map-dialog': true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }"
        (onShow)="onDrawPolygonDialogOpen()">
        <p-card class="map-card">
          <ng-template pTemplate="content">
                <div class="map-container" style="direction: ltr; width: 100%; ">
                <app-arcgis-map 
                  *ngIf="isDrawPolygon"
                  [mapControls]="mapControls" 
                  [lang]="currentLanguage" 
                  [enableSketching]="true"
                  [sketchShapes]="regions"
                  (sketchShapesChanged)="handleSketchShapesChanged($event)">
                </app-arcgis-map>
                </div>
          </ng-template>
        </p-card>
        <div [ngClass]="{'dialog-footer':true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
          <p-button [id]="'cancel'" dir="ltr" (onClick)="cancelDrawingPolygons()"
            (keydown.enter)="cancelDrawingPolygons()" [rounded]="true" [styleClass]="'prime1-button'"
            [label]="'iaa.cancel' | translate" [tabIndex]="0">
            <span style="margin-right: 5px;"><i class="fa fa-times"></i></span>
          </p-button>
          <p-button dir="ltr" [id]="'ok'" (onClick)="drawPolygons()" (keydown.enter)="drawPolygons()" [rounded]="true"
            [styleClass]="'prime-button'" [label]="'iaa.general.ok' | translate" [tabIndex]="0">
            <span style="margin-right: 5px;"> <i class="fa fa-check"></i></span>
          </p-button>
        </div>
      </p-dialog>
      <p-dialog [closeAriaLabel]=" 'iaa.general.closePane' | translate " [(visible)]="isSettlementVisible"
      [dismissableMask]="true" [modal]="true" [header]="'iaa.app.advancedSearch.selectSettlement' | translate"
      (onHide)="onDialogHide('settlement')"
      [ngClass]="{ 'dialog': true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
      <search-dialog *ngIf="isSettlementVisible" (onToggleTag)="toggleField(RequestKeys.SETTLEMENT_IDS, $event)" [key]="'id'"
        [fieldName]="'name'" [fieldNameByLang]="'iaa.app.advancedSearch.settlement' | translate"
        [isVisible]="isSettlementVisible" [values]="fieldsLists.settlements" [currentLanguage]="currentLanguage">
      </search-dialog>
      <div [ngClass]="{'dialog-footer':true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
        <p-button [id]="'ok'" (onClick)="isSettlementVisible = false" (keydown.enter)="isSettlementVisible = false"
          [rounded]="true" [styleClass]="'prime-button'" [label]="'iaa.general.ok' | translate" [tabIndex]="0" />
      </div>
    </p-dialog>
    </div>

    <!-- Hachraza (Declared Archeological Site) -->
    <div [class.selected]="isHachrazaVisible" class="item-container">
      <div class="search-field">
        <div #hachrazaOpener id="hachrazaOpener" role="button" aria-describedby="search-info" tabindex="0" (click)="isHachrazaVisible = true"
          (keydown.enter)="isHachrazaVisible = true" class="open-dialog-btn">
          <i class="pi pi-plus-circle cursor-pointer ml-2 text-white border-circle plus-icon shadow-2 text-xl"
            [ngClass]="{ 'en': currentLanguage === 'en', 'he': currentLanguage === 'he' }"></i>
          <label class="item-label" htmlFor="hachraza">{{'iaa.app.advancedSearch.declaredSiteHeritage' | translate}}</label>
        </div>
      </div>
      <app-filter-tags (removeTag)="removeTag($event, RequestKeys.HACHRAZOT)"
        [tagList]="searchFields[RequestKeys.HACHRAZOT]" />
      <p-dialog [closeAriaLabel]=" 'iaa.general.closePane' | translate " [(visible)]="isHachrazaVisible"
        [dismissableMask]="true" [header]="'iaa.app.advancedSearch.selectSite' | translate" [modal]="true"
        (onHide)="onDialogHide('hachraza')"
        [ngClass]="{ 'dialog': true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
        <search-dialog *ngIf="isHachrazaVisible" (onToggleTag)="toggleField(RequestKeys.HACHRAZOT, $event)" [key]="'hachrazaEntityId'"
          [fieldName]="'name'" [fieldNameByLang]=" 'iaa.general.site' | translate "
          [isVisible]="isHachrazaVisible" [values]="fieldsLists.hachrazot" [currentLanguage]="currentLanguage" />
        <div [ngClass]="{'dialog-footer':true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
          <p-button [id]="'ok'" (onClick)="isHachrazaVisible = false" (keydown.enter)="isHachrazaVisible = false"
            [rounded]="true" [styleClass]="'prime-button'" [label]="'iaa.general.ok' | translate" [tabIndex]="0" />
        </div>
      </p-dialog>
    </div>

    <!-- Heritage Sites (internal users only) -->
    <div *ngIf="isInternalUser" [class.selected]="isHeritageSiteVisible" class="item-container">
      <div class="search-field">
        <div #heritageSiteOpener id="heritageSiteOpener" role="button" aria-describedby="search-info" tabindex="0" (click)="isHeritageSiteVisible = true"
          (keydown.enter)="isHeritageSiteVisible = true" class="open-dialog-btn">
          <i class="pi pi-plus-circle cursor-pointer ml-2 text-white border-circle plus-icon shadow-2 text-xl"
            [ngClass]="{ 'en': currentLanguage === 'en', 'he': currentLanguage === 'he' }"></i>
          <label class="item-label" htmlFor="heritageSite">{{'iaa.app.advancedSearch.heritageSite' | translate}}</label>
        </div>
      </div>
      <app-filter-tags (removeTag)="removeTag($event, RequestKeys.HERITAGE_SITE_IDS)"
        [tagList]="searchFields[RequestKeys.HERITAGE_SITE_IDS]" />
      <p-dialog [closeAriaLabel]=" 'iaa.general.closePane' | translate " [(visible)]="isHeritageSiteVisible"
        [dismissableMask]="true" [modal]="true" [header]="'iaa.app.advancedSearch.selectHeritageSite' | translate"
        (onHide)="onDialogHide('heritageSite')"
        [ngClass]="{ 'dialog': true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
        <app-thesaurus-search-tree *ngIf="isHeritageSiteVisible"
          (onToggle)="toggleField(RequestKeys.HERITAGE_SITE_IDS, $event)"
          [tree]="$any(fieldsLists.heritageSites)"
          [currentLanguage]="currentLanguage"
          [enableVirtualScroll]="true"
          [showHoverLabel]="true"
          [tempSelections]="searchFields[RequestKeys.HERITAGE_SITE_IDS]">
        </app-thesaurus-search-tree>
        <div [ngClass]="{'dialog-footer':true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
          <p-button [id]="'ok'" (onClick)="isHeritageSiteVisible = false" (keydown.enter)="isHeritageSiteVisible = false"
            [rounded]="true" [styleClass]="'prime-button'" [label]="'iaa.general.ok' | translate" [tabIndex]="0" />
        </div>
      </p-dialog>
    </div>
    <div [class.selected]="isPersonVisible" class="item-container">
      <div class="search-field">
        <div #personOpener id="personOpener" role="button" aria-describedby="search-info" tabindex="0" (click)="isPersonVisible = true"
          (keydown.enter)="isPersonVisible = true" class="open-dialog-btn">
          <i class="pi pi-plus-circle cursor-pointer ml-2 text-white border-circle plus-icon shadow-2 text-xl"
            [ngClass]="{ 'en': currentLanguage === 'en', 'he': currentLanguage === 'he' }"></i>
          <label class="item-label" htmlFor="persons">{{ 'iaa.app.advancedSearch.researcher' | translate }}
          </label>
        </div>
      </div>
      <app-filter-tags (removeTag)="removeTag($event, RequestKeys.PERSONS)"
        [tagList]="searchFields[RequestKeys.PERSONS]" />
      <p-dialog [closeAriaLabel]=" 'iaa.general.closePane' | translate " [(visible)]="isPersonVisible"
        [dismissableMask]="true" [header]=" 'iaa.app.advancedSearch.selectResearcher' | translate " [modal]="true"
        (onHide)="onDialogHide('person')"
        [ngClass]="{ 'dialog': true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
        <search-dialog *ngIf="isPersonVisible" (onToggleTag)="toggleField(RequestKeys.PERSONS, $event)" [key]="'entityPersonId'" [fieldName]="'name'"
          [fieldNameByLang]=" 'iaa.app.advancedSearch.researcher' | translate " [isVisible]="isPersonVisible"
          [values]="fieldsLists.persons" [currentLanguage]="currentLanguage" />
        <div [ngClass]="{'dialog-footer':true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
          <p-button [id]="'ok'" (onClick)="isPersonVisible = false" (keydown.enter)="isPersonVisible = false"
            [rounded]="true" [styleClass]="'prime-button'" [label]="'iaa.general.ok' | translate" [tabIndex]="0" />
        </div>
      </p-dialog>
    </div>
    <!-- Advanced Thesaurus Search -->
    <div [class.selected]="isThesaurusAdvancedVisible" class="item-container">
      <div class="search-field">
        <div #thesaurusAdvancedOpener id="thesaurusAdvancedOpener" role="button" aria-describedby="search-info" tabindex="0" (click)="openThesaurusAdvanced()"
          (keydown.enter)="openThesaurusAdvanced()" class="open-dialog-btn">
          <i class="pi pi-plus-circle cursor-pointer ml-2 text-white border-circle plus-icon shadow-2 text-xl"
            [ngClass]="{ 'en': currentLanguage === 'en', 'he': currentLanguage === 'he' }"></i>
          <label class="item-label" htmlFor="thesaurusAdvanced">{{'iaa.app.advancedSearch.advancedThesaurus' | translate}}</label>
        </div>
        <img class="find-type-image" [ngClass]="{'icon-book':currentLanguage ==='en'}" src="assets/book.svg" alt="" />
      </div>
      <app-thesaurus-filter-tags (removeTag)="removeTag($event, RequestKeys.ADVANCED_THESAURUS)"
        (searchTypeChange)="onSearchTypeChange($event)"
        [tagList]="searchFields[RequestKeys.ADVANCED_THESAURUS]" />

      <!-- Tree Selection Dialog with Category Dropdown -->
      <p-dialog [closeAriaLabel]="'iaa.general.closePane' | translate" 
        [(visible)]="isThesaurusAdvancedVisible"
        [dismissableMask]="true" [modal]="true" 
        (onShow)="onThesaurusDialogShow()"
        (onHide)="onDialogHide('thesaurusAdvanced')"
        [styleClass]="'thesaurus-advanced-dialog ' + (currentLanguage === 'he' ? 'he' : 'en')">
        <ng-template pTemplate="header">
          <div class="title thesaurus-dialog-title">
            <h2 class="dialog-header-title" id="thesaurus-advanced-title">
              {{'iaa.app.advancedSearch.advancedThesaurus' | translate}}
            </h2>
            <i tabIndex="0" role="button" class="pi pi-info-circle"
              [ngClass]="{currentLang:true,'info-icon' : true, 'en': currentLanguage ==='en'}" tooltipEvent="both"
              [tooltipPosition]="currentLanguage === 'en' ? 'right' : 'left'"
              [attr.aria-description]=" 'iaa.app.advancedSearch.advancedThesaurusInfoDescription' | translate "
              [attr.aria-label]="'iaa.aria.info' | translate "
              [pTooltip]=" 'iaa.app.advancedSearch.advancedThesaurusInfoDescription' | translate ">
            </i>
          </div>
        </ng-template>
        <!-- Content - Only show when data is loaded -->
        <ng-container>
          <div class="thesaurus-dialog-body">
            <!-- Category Dropdown -->
            <div class="category-dropdown-container" [ngClass]="{ 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
              <label class="category-dropdown-label" [id]="'categoryDropdownLabel-' + currentLanguage">{{'iaa.app.advancedSearch.selectThesaurusCategory' | translate}}</label>
              <p-autoComplete
                #categoryAutoComplete
                [(ngModel)]="selectedThesaurusCategory"
                [suggestions]="filteredCategories"
                (completeMethod)="filterCategories($event)"
                (onSelect)="onCategorySelect($event)"
                [showClear]="true"
                [dropdown]="true"
                [field]="'displayText'"
                [placeholder]="'iaa.app.advancedSearch.selectThesaurusCategory' | translate"
                [styleClass]="'w-full'"
                [inputStyleClass]="'w-full'"
                [scrollHeight]="'500px'"
                [forceSelection]="true"
                [dropdownAriaLabel]="'iaa.app.advancedSearch.selectThesaurusCategory' | translate"
                [attr.aria-labelledby]="'categoryDropdownLabel-' + currentLanguage">
                <ng-template let-category pTemplate="item">
                  <div>{{ category.displayText }}</div>
                </ng-template>
              </p-autoComplete>
            </div>
        <div *ngIf="isThesaurusDataLoading" class="thesaurus-loading">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem;"></i>
          <p>{{'iaa.general.loading' | translate}}</p>
        </div>
        <!-- Placeholder spacer when no category selected to maintain dialog size -->
        <div *ngIf="!activeThesaurusCategory || isThesaurusDataLoading" class="dialog-spacer"></div>

        <!-- Main Content: Tree and Preview Panel (only shown when category selected) -->
        <div *ngIf="activeThesaurusCategory" class="thesaurus-advanced-content" [ngClass]="{ 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
          <!-- Preview Panel (Left for Hebrew, Right for English) -->
          <div class="preview-panel" [ngClass]="{ 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
            <h3 class="preview-title">{{'iaa.app.advancedSearch.selectedItems' | translate}}</h3>
            
            <!-- Empty State -->
            <div class="no-selections" *ngIf="getTempSelectionsGroupedByCategory().length === 0">
              <img src="assets/empty-selections.svg" alt="{{'iaa.app.advancedSearch.noSelections' | translate}}" />
            </div>
            
            <!-- Tags Grouped by Category -->
            <div class="selections-container" *ngIf="getTempSelectionsGroupedByCategory().length > 0">
              <div *ngFor="let group of getTempSelectionsGroupedByCategory()" class="category-group">
                <div class="category-label">{{ group.categoryName }}</div>
                <app-thesaurus-filter-tags 
                  (removeTag)="removeTagFromTempSelections($event)"
                  (searchTypeChange)="onPreviewPanelSearchTypeChange($event)"
                  [tagList]="group.selections">
                </app-thesaurus-filter-tags>
              </div>
            </div>
          </div>

          <!-- Tree -->
          <div class="tree-panel">
            <!-- Show tree when category is selected -->
            <app-thesaurus-search-tree #advancedThesaurusTree
              (onToggle)="toggleField(RequestKeys.ADVANCED_THESAURUS, $event)" 
              (searchTypeChange)="onTreeNodeSearchTypeChange($event)"
              *ngIf="currentAdvancedThesaurusTree"
              [tree]="currentAdvancedThesaurusTree"
              [showFilter]="true"
              [tempSelections]="getCurrentCategoryTempSelections()"
              [searchTypePreferences]="getCurrentCategorySearchTypePreferences()"
              [currentLanguage]="currentLanguage" />
          </div>
        </div>
          </div>
        </ng-container>
        
        <div [ngClass]="{'dialog-footer':true, 'thesaurus-footer': true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }" *ngIf="!isThesaurusDataLoading && activeThesaurusCategory">
          <!-- Legend Section -->
          <div class="thesaurus-legend" 
               [ngClass]="{ 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }"
               role="region"
               [attr.aria-label]="'iaa.app.advancedSearch.legendTitle' | translate">
            <!-- First Line: Word Types -->
            <div class="legend-line">
              <span class="legend-item">
                <img src="assets/equal.svg" 
                     [attr.alt]="'iaa.app.advancedSearch.equalWords' | translate" 
                     class="legend-icon" 
                     aria-hidden="true" />
                <span class="legend-text">{{ 'iaa.app.advancedSearch.equalWords' | translate }}</span>
              </span>
              <span class="legend-item">
                <img src="assets/unpref.svg" 
                     [attr.alt]="'iaa.app.advancedSearch.unpreferredWords' | translate" 
                     class="legend-icon" 
                     aria-hidden="true" />
                <span class="legend-text">{{ 'iaa.app.advancedSearch.unpreferredWords' | translate }}</span>
              </span>
            </div>
            <!-- Second Line: Search Depth -->
            <div class="legend-line">
              <span class="legend-label">{{ 'iaa.app.advancedSearch.searchDepth' | translate }}</span>
              <span class="legend-item">
                <img src="assets/branch.svg" 
                     [attr.alt]="'iaa.app.advancedSearch.searchTypeBranch' | translate" 
                     class="legend-icon" 
                     aria-hidden="true" />
                <span class="legend-text">{{ 'iaa.app.advancedSearch.searchTypeBranch' | translate }}</span>
              </span>
              <span class="legend-item">
                <img src="assets/mid.svg" 
                     [attr.alt]="'iaa.app.advancedSearch.searchTypeMid' | translate" 
                     class="legend-icon" 
                     aria-hidden="true" />
                <span class="legend-text">{{ 'iaa.app.advancedSearch.searchTypeMid' | translate }}</span>
              </span>
              <span class="legend-item">
                <img src="assets/wid.svg" 
                     [attr.alt]="'iaa.app.advancedSearch.searchTypeWid' | translate" 
                     class="legend-icon" 
                     aria-hidden="true" />
                <span class="legend-text">{{ 'iaa.app.advancedSearch.searchTypeWid' | translate }}</span>
              </span>
            </div>
          </div>
          
          <!-- Action Buttons -->
          <div class="footer-buttons">
            <p-button [id]="'ok'" dir="ltr" (onClick)="closeThesaurusAdvanced()" 
              (keydown.enter)="closeThesaurusAdvanced()"
              [rounded]="true" [styleClass]="'prime-button'" [label]="'iaa.general.ok' | translate" [tabIndex]="0">
            </p-button>
          </div>
        </div>
      </p-dialog>
    </div>
    <div class="item-container no-border">
      <div class="flex flex-row align-items-center">
        <label class="item-label" htmlFor="free text" id="free-text-label">{{'iaa.general.freeTextSearch' |
          translate}}</label>
      </div>
      <div class="flex flex-column gap-2 w-full">
        <div class="input-container">
          <div class="input-wrapper">
            <input (keydown.enter)="addFreeTextTag()" [(ngModel)]="freeText" class="text-input"
              aria-labelledby="free-text-label" id="free-text" tabIndex="0" />
            <p-button [id]="'add'" (onClick)="addFreeTextTag()" (keydown.enter)="addFreeTextTag()"
              [disabled]="freeText.trim() === ''" [link]="true" class="flex mt-2"
              [ngClass]="{'add-button': true, 'en':currentLanguage==='en',  'he': currentLanguage==='he'}"
              [label]=" 'iaa.general.add' | translate " [aria-label]=" 'iaa.general.add' | translate " />
          </div>
        </div>
      </div>
      <app-filter-tags (removeTag)="removeTag($event, RequestKeys.FREE_TEXT)"
        [tagList]="searchFields[RequestKeys.FREE_TEXT]" />
    </div>
    <div class="search-info">
      <img [ngClass]="{'icon-book':currentLanguage ==='en'}" src="assets/book.svg" alt="" />
      <div class="search-info-text star" aria-hidden="true">*</div>
      <div class="search-info-text" id="search-info" aria-hidden="true">
        {{'iaa.app.advancedSearch.searchRemark' | translate }}
      </div>
    </div>
    <p-toast></p-toast>
  </div>
  <div *ngIf="!isSearchValid" class="error-message">{{ 'iaa.general.searchDataMustAdded' | translate }} </div>
  <div class="row-buttons">
    <p-button [id]="'clearSearchFields'" (onClick)="clear()" (keydown.enter)="clear()" [hidden]="isLoading"
      [label]=" 'iaa.aria.clearSearchFields' | translate " [link]="true" [rounded]="true"
      [ariaLabel]=" 'iaa.aria.clearSearchFields' | translate " styleClass="p-button-rounded clear-button" />
    <p-button [id]="'cancel'" (onClick)="cancel()" (keydown.enter)="cancel()" [hidden]="!isLoading" [rounded]="true"
      [label]=" 'iaa.aria.cancelSearch' | translate " [styleClass]="'prime-button'"
      [ariaLabel]=" 'iaa.aria.cancelSearch' | translate " />
    <p-button [id]="'search'" (onClick)="search()" (keydown.enter)="search()" [hidden]="isLoading" [loading]="isLoading"
      [label]=" 'iaa.aria.search' | translate " [rounded]="true" [disabled]="isDrawPolygon"
      [styleClass]="'prime-button'" [ariaLabel]=" 'iaa.aria.search' | translate " />
  </div>
  
  <!-- Search Settings Dialog -->

</p-panel>
  <p-dialog [closeAriaLabel]="'iaa.general.closePane' | translate" [(visible)]="isSearchSettingsVisible"
    [dismissableMask]="true" [modal]="true" [header]="'iaa.app.advancedSearch.searchSettings' | translate"
    (onHide)="onSearchSettingsDialogHide()" (onShow)="onSearchSettingsDialogShow()"
    [appendTo]="'body'" [styleClass]="currentLanguage === 'he' ? 'search-settings-dialog he' : 'search-settings-dialog en'">
    <ng-template pTemplate="header">
      <h2 id="search-settings-header" class="dialog-header-title">{{'iaa.app.advancedSearch.searchSettings' | translate}}</h2>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="search-settings-content" 
        [ngClass]="{ 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
        <div class="setting-item">
          <p-inputSwitch inputId="thesaurus-ancestors-switch" [(ngModel)]="tempWithThesaurusAncestors" />
          <label for="thesaurus-ancestors-switch" class="setting-label">
            {{'iaa.app.advancedSearch.withThesaurusAncestorsLabel' | translate}}
            <i tabIndex="0" role="button" class="pi pi-info-circle info-icon" tooltipEvent="both"
              (click)="$event.stopPropagation(); $event.preventDefault()"
              (mousedown)="$event.stopPropagation(); $event.preventDefault()"
              [tooltipPosition]="currentLanguage === 'en' ? 'right' : 'left'"
              [attr.aria-description]="'iaa.app.advancedSearch.withThesaurusAncestorsTooltip' | translate"
              [attr.aria-label]="'iaa.aria.info' | translate"
              [pTooltip]="'iaa.app.advancedSearch.withThesaurusAncestorsTooltip' | translate"></i>
          </label>
        </div>
        <div class="setting-item">
          <p-inputSwitch inputId="entity-ancestors-switch" [(ngModel)]="tempWithEntityAncestors" />
          <label for="entity-ancestors-switch" class="setting-label">
            {{'iaa.app.advancedSearch.withEntityAncestorsLabel' | translate}}
            <i tabIndex="0" role="button" class="pi pi-info-circle info-icon" tooltipEvent="both"
              (click)="$event.stopPropagation(); $event.preventDefault()"
              (mousedown)="$event.stopPropagation(); $event.preventDefault()"
              [tooltipPosition]="currentLanguage === 'en' ? 'right' : 'left'"
              [attr.aria-description]="'iaa.app.advancedSearch.withEntityAncestorsTooltip' | translate"
              [attr.aria-label]="'iaa.aria.info' | translate"
              [pTooltip]="'iaa.app.advancedSearch.withEntityAncestorsTooltip' | translate"></i>
          </label>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <div [ngClass]="{'dialog-footer':true, 'he': currentLanguage === 'he', 'en': currentLanguage === 'en' }">
        <p-button [id]="'ok'" (onClick)="applySearchSettings()" (keydown.enter)="applySearchSettings()"
          [rounded]="true" [styleClass]="'prime-button'" [label]="'iaa.general.ok' | translate" [tabIndex]="0" />
      </div>
    </ng-template>
  </p-dialog>